// Hash routes keep this isolated HTML preview reloadable without a server rewrite.
// URL state is navigation only, NEVER an authorization input.
export type PreviewRoute = { department: string | null; report: string | null; invalid: boolean; growth?: boolean };
const segment = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
export function catalogHref(department: string | null, report: string | null = null): string {
  if (department === null) return '#/';
  if (!segment.test(department) || (report !== null && !segment.test(report))) return '#/invalid';
  return `#/departments/${department}${report === null ? '' : `/reports/${report}`}`;
}
export function parsePreviewRoute(hash: string): PreviewRoute {
  if (hash === '#/growth') return { department: null, report: null, invalid: false, growth: true };
  if (!hash || hash === '#/' || hash === '#') return { department: null, report: null, invalid: false };
  const match = /^#\/departments\/([a-z0-9-]+)(?:\/reports\/([a-z0-9-]+))?$/.exec(hash);
  if (!match || !segment.test(match[1]) || (match[2] && !segment.test(match[2]))) {
    return { department: null, report: null, invalid: true };
  }
  return { department: match[1], report: match[2] ?? null, invalid: false };
}
